import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import BannerInquiry from "./BannerInquiry";
import { useRef } from "react";
import ModalPop from "./ModalPop";

const Banner = () => {
  const bannerList = [
    {
      pc: "/images/banner1.webp",
      mo: "/images/bannerM1.webp",
      txt: "/images/bannerT1.webp",
    },
    {
      pc: "/images/banner2.webp",
      mo: "/images/bannerM2.webp",
      txt: "/images/bannerT2.webp",
    },
    {
      pc: "/images/banner2.webp",
      mo: "/images/bannerM2.webp",
      txt: "/images/bannerT3.webp",
    },
  ];

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="relative w-full h-full grid grid-rows-2 xl:grid-rows-1 xl:grid-cols-2  bg-primary">
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          loop={true}
          navigation={false}
          modules={[Autoplay]}
          className="mySwiper relative w-full h-full lg:h-[760px]"
        >
          {bannerList.map((v, i) => (
            <SwiperSlide key={i} className=" relative w-full h-full">
              <div className="absolute right-0 top-0 w-full h-full z-10">
                <div className=" relative w-full h-full grid items-center xl:justify-end px-5 lg:pl-0 lg:pr-10 xl:pr-14">
                  <div className="relative w-fit h-fit mx-auto xl:mx-0">
                    <img
                      src={v.txt}
                      alt="카이노스 바이오케미칼 친환경 외벽 드론청소 소개"
                      width={1041}
                      height={480}
                      className="!relative w-full h-full object-contain max-h-72"
                    />
                    <div className="flex justify-end items-center gap-2 mt-8">
                      <button onClick={openfunc} type="button">
                        <img
                          src="/images/bannerIcon1.webp"
                          alt="무료 상담 신청"
                          className="!relative w-full h-full object-contain max-w-44"
                        />
                      </button>
                      <button onClick={openfunc} type="button">
                        <img
                          src="/images/bannerIcon2.webp"
                          alt="무료 견적 신청"
                          className="!relative w-full h-full object-contain max-w-44"
                        />
                      </button>
                      <button
                        type="button"
                        onClick={() =>
                          (window.location.href = "tel:010-7557-1757")
                        }
                      >
                        <img
                          src="/images/bannerIcon3.webp"
                          alt="전화 문의 010-7557-1757"
                          className="!relative w-full h-full object-contain max-w-44"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <img
                className="relative w-full h-full xl:h-[800px] object-coverobject-left"
                src={v.pc}
                alt="카이노스 바이오케미칼 외벽 드론청소 서비스 배너"
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="relative w-full h-full -mt-8 lg:mt-0 grid items-center bg-primary px-3 lg:px-0 z-10 py-6 lg:pb-0">
          <div className="relative w-fit h-fit mx-auto xl:ml-5 2xl:ml-10 max-w-screen-md">
            <div className=" relative w-full h-fit flex items-end justify-between lg:px-5">
              <div className="relative w-fit h-full flex items-center gap-2 lg:gap-5 pb-2">
                <img
                  alt="카이노스 바이오케미칼 로고"
                  className="!relative w-full h-full max-w-md max-h-10 lg:max-h-12 xl:max-h-[54px] py-1 object-contain cursor-pointer"
                  src="/images/whiteLogo.webp"
                  width={285}
                  height={67}
                />

                <div className=" relative w-fit h-fit pt-1 px-2 lg:px-5 bg-white text-primary">
                  <h4 className="font-normal">상세&nbsp;견적문의</h4>
                </div>
              </div>
              <div className=" relative w-fit h-fit mx-auto">
                <img
                  src="/images/bannerIcon.webp"
                  alt="상세 견적문의 안내"
                  className="!relative w-auto h-full object-contain max-h-20 lg:max-h-32 xl:max-h-40"
                />
              </div>
            </div>
            <div className=" relative w-full h-fit lg:px-5">
              <div className="py-5 bg-white rounded-xl">
                <BannerInquiry />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
